module.exports = __webpack_public_path__ + "img/Flohmarkt.b50c8268.svg";